module.exports = __webpack_public_path__ + "img/售后服务引擎.c86b531a.png";